import { SubflowStateViewModelValidator } from './SubflowStateViewModelValidator';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
export class SubflowViewModelValidator {
    constructor() {
        this.stateViewModelValidator = new SubflowStateViewModelValidator();
    }
    validate(model) {
        const stateIds = Object.keys(model);
        const validationErrors = [];
        for (let i = 0; i < stateIds.length; i++) {
            const stateViewModel = model[stateIds[i]];
            if (!this.stateViewModelValidator.isValid(stateViewModel)) {
                validationErrors.push(stateViewModel.$validationError);
            }
        }
        if (validationErrors.length > 0) {
            throw new ValidationError(`One or more validation errors occurred: ${validationErrors
                .map((e) => e.message)
                .join()}`);
        }
    }
}
